export default "__VITE_ASSET__6bnsxQ$4__"